var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMutualIcAddPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vfs83k3e0a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "my2mscfwub",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5awqxe9whc",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#vfs83k3e0a)",
    d: "M8.889 3.333c0 3.062 2.515 5.556 5.555 5.556 1.24 0 2.4-.425 3.334-1.135v4.765c0 3.146-2.024 5.259-5.038 5.259H5.037C2.024 17.778 0 15.665 0 12.519V5.26C0 2.114 2.024 0 5.037 0l4.98-.001C9.312.931 8.89 2.089 8.89 3.333z",
    transform: "translate(-631 -356) translate(452 222) translate(90 60) translate(43 74) translate(46) translate(0 2.222)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#my2mscfwub)",
    d: "M11.39 9.55c.198-.262.935-1.082 1.887-.498.607.367 1.117.865 1.663 1.397.209.204.358.436.456.684.298.75.143 1.65-.175 2.393-.377.884-1.1 1.551-2.01 1.843-.403.13-.827.187-1.25.187H4.47c-.746 0-1.405-.175-1.946-.503-.339-.206-.399-.679-.147-.987.42-.513.834-1.028 1.253-1.548.797-.995 1.334-1.283 1.931-1.03.243.104.486.262.736.428.667.445 1.594 1.056 2.815.393.84-.463 1.325-1.258 1.749-1.946.173-.28.338-.56.53-.813zM5.43 3.333c1.224 0 2.22 1.006 2.22 2.24 0 1.234-.996 2.239-2.22 2.239-1.226 0-2.222-1.005-2.222-2.239s.996-2.24 2.222-2.24z",
    transform: "translate(-631 -356) translate(452 222) translate(90 60) translate(43 74) translate(46) translate(0 2.222)"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#5awqxe9whc)",
    d: "M4.444 8.889c2.415 0 4.445-2.012 4.445-4.445C8.889 2.012 6.885 0 4.444 0 2.012 0 0 2.012 0 4.444 0 6.894 2.012 8.89 4.444 8.89z",
    transform: "translate(-631 -356) translate(452 222) translate(90 60) translate(43 74) translate(46) translate(10 1.111)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.453 7.222c-.306 0-.576-.202-.576-.513V4.958H2.208c-.297 0-.541-.236-.541-.514 0-.277.244-.513.541-.513h1.669V2.189c0-.32.27-.522.576-.522.297 0 .568.202.568.522V3.93h1.668c.297 0 .533.236.533.513 0 .278-.236.514-.533.514H5.021v1.75c0 .312-.27.514-.568.514z",
    transform: "translate(-631 -356) translate(452 222) translate(90 60) translate(43 74) translate(46) translate(10 1.111)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutualIcAddPhoto);
export default __webpack_public_path__ + "static/media/mutual-ic-add-photo.95b7bf81.svg";
export { ForwardRef as ReactComponent };